import Vue from "vue";
import FilePreviewDialog from "@/components/FilePreviewDialog.vue";
import { normalizeAttachmentFiles } from "@/utils/handlePicOPdf";

let previewHost;

// 上传组件和独立预览入口共用 FilePreviewDialog，不再维护页面专用弹窗。
export function previewFiles(files, initialIndex = 0) {
  const normalizedFiles = normalizeAttachmentFiles(files);
  if (!normalizedFiles.length) return;
  if (!previewHost) {
    previewHost = new Vue({
      parent: this && this.$root,
      data: { visible: false, files: [], initialIndex: 0, revision: 0 },
      render(h) {
        return h(FilePreviewDialog, {
          key: this.revision,
          props: { show: this.visible, files: this.files, initialIndex: this.initialIndex },
          on: { "update:show": (show) => { this.visible = show; } },
        });
      },
    }).$mount();
    document.body.appendChild(previewHost.$el);
  }
  previewHost.files = normalizedFiles;
  previewHost.initialIndex = Math.min(Math.max(Number(initialIndex) || 0, 0), normalizedFiles.length - 1);
  previewHost.revision += 1;
  previewHost.visible = true;
}

export function closeFilePreview() {
  if (previewHost) previewHost.visible = false;
}
